/* eslint-disable eqeqeq */
import React from 'react';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import { makeStyles } from '@material-ui/core/styles';
import TableRow from '@material-ui/core/TableRow';
import FormItensNfe from '../form-itens-nfce';
import api from '../../../services/api';
import DeleteIcon from '@material-ui/icons/Delete';
import IconButton from '@material-ui/core/IconButton';
import Swal from 'sweetalert2';
import Grid from '@material-ui/core/Grid';

const useStyles = makeStyles(theme => ({
    root: {
        width: '100%',
        marginBottom: 5,
    },
    tableWrapper: {
        maxHeight: 440,
        overflow: 'auto',
    },
    ocultaCampo: {
        display: "none",
    },
}));


export default function ListagemNfeProduto(props) {

    const { itensNota,
        adicionarItem,
        removerItem,
        inativo,
        autorizada } = props;
    const classes = useStyles();

    async function deletar(codigoItem, indexProduto) {
        Swal.fire({
            type: "question",
            title: 'Deletar Item ?',
            showCancelButton: true,
            confirmButtonText: 'Sim',
            cancelButtonText: 'Cancelar',
            showLoaderOnConfirm: true,
            preConfirm: (result) => {
                return new Promise(async (resolve, reject) => {
                    if (codigoItem) {

                        let dadosEnvio = {
                            DBSERVERNAME: localStorage.getItem("DBSERVERNAME"),
                            DBUSERNAME: localStorage.getItem("DBUSERNAME"),
                            DBESQUEMA: localStorage.getItem("DBESQUEMA"),
                            DBPID: localStorage.getItem("DBPID"),
                            MANDNUMBER: localStorage.getItem("MANDNUMBER"),
                            PROCNAME: "WEBSITE_NFEI_DELETE",
                            EMPNUMBER: localStorage.getItem("EMPNUMBER"),
                            PCNRNFI: codigoItem
                        };

                        const resposta = await api.post('/execute', dadosEnvio);

                        if (resposta.data.CODIGO_ERRO == 0) {
                            resolve();
                            // removerItem(indexProduto);
                            // const Toast = Swal.mixin({
                            //     toast: true,
                            //     position: 'top-right',
                            //     showConfirmButton: false,
                            //     timer: 3000,
                            //     timerProgressBar: true,
                            //     onOpen: (toast) => {
                            //         toast.addEventListener('mouseenter', Swal.stopTimer)
                            //         toast.addEventListener('mouseleave', Swal.resumeTimer)
                            //     }
                            // })

                            // Toast.fire({
                            //     type: 'success',
                            //     title: 'Item Removido'
                            // })
                        }
                    } else {
                        removerItem(indexProduto);
                        resolve();
                        // const Toast = Swal.mixin({
                        //     toast: true,
                        //     position: 'top-right',
                        //     showConfirmButton: false,
                        //     timer: 3000,
                        //     timerProgressBar: true,
                        //     onOpen: (toast) => {
                        //         toast.addEventListener('mouseenter', Swal.stopTimer)
                        //         toast.addEventListener('mouseleave', Swal.resumeTimer)
                        //     }
                        // })

                        // Toast.fire({
                        //     type: 'success',
                        //     title: 'Item Removido'
                        // })
                    }

                });

            },
            allowOutsideClick: () => !Swal.isLoading()
        }).then((result) => {
            if (result.value) {
                Swal.fire({
                    type: 'success',
                    title: 'Item Removido'
                })
            }

        });

    }

    return (
        <>
            <Paper className={itensNota.length == 0 ? classes.ocultaCampo : classes.root}>
                <div className={classes.tableWrapper}>
                    <Table stickyHeader aria-label="sticky table">
                        <TableHead>
                            <TableRow>
                                <TableCell>Ação</TableCell>
                                <TableCell>Produto</TableCell>
                                <TableCell>Descrição</TableCell>
                                <TableCell>Quantidade</TableCell>
                                <TableCell>Preço</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {itensNota.map((item, indexItem) => (
                                <TableRow key={item.codigoItem}>
                                    <TableCell>
                                        <Grid container>
                                            <Grid item xs={autorizada ? 12 : 6}>
                                                <FormItensNfe
                                                    adicionarItem={adicionarItem}
                                                    removerItem={removerItem}
                                                    grid="true"
                                                    produtoNfe={item}
                                                    indexProduto={indexItem}
                                                    inativo={inativo}
                                                />
                                            </Grid>
                                            {!autorizada &&
                                                <Grid item xs={6}>
                                                    <IconButton aria-label="alterar"
                                                        onClick={() => deletar(item.codigoItem, indexItem)}
                                                    >
                                                        <DeleteIcon />
                                                    </IconButton>
                                                </Grid>
                                            }
                                        </Grid>
                                    </TableCell>
                                    <TableCell>{item.produto}</TableCell>
                                    <TableCell>{item.descricaoProduto}</TableCell>
                                    <TableCell>{item.quantidade}</TableCell>
                                    <TableCell>{item.preco}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </div>
            </Paper>
        </>

    )
}